// extracted by mini-css-extract-plugin
module.exports = {"warning":"styles__warning___2jLN4","icon":"styles__icon___3-aST"};